export default class NotLoggedInError extends Error {
  constructor() {
    super('NotLoggedInError')
  }
}
